import { Message } from 'element-ui';
import VueI18n from '../i18n/langs/index';


// 保存提示
export function save_hint_test() {
    console.log(11)
    Message({
        message: VueI18n.t("anti_gs1_tan.save_load"),
        type: 'warning',
        showClose: true,
        duration: 0,
    });
}
// 关闭保存提示
export function close_hint_test() {

    Message.closeAll()

}
export function search_hint_test() {
    console.log(11)
    Message({
        message: VueI18n.t("anti_gs1_tan.search_load"),
        type: 'warning',
        showClose: true,
        duration: 0,
    });
}
export function close_search_hint_test() {

    Message.closeAll()

}
// 禁止使用
export function disable_hint_test() {
    this.$root.jurisdiction.only_query = 0

}
export function close_disable_hint_test() {
    this.$root.jurisdiction.only_query = 1



}